export const getSiteKey = () => window.config.ysc_public_key;
export const getVerifyUrl = () => '/rest/v1/captcha/smart';
export const getIsVerifiedUrl = () => '/rest/v1/captcha/smart/isVerified';
/**
 * События для Emitter
 */
export const SmsEvent = {
  /** открывает окно капчи с запросом кода смс */
  ON_GET_PHONE_CODE: Symbol('ON_GET_PHONE_CODE'),
  /** когда смс капчи подтвержден */
  ON_CONFIRMED: Symbol('ON_CONFIRMED'),
  /** когда окно капчи закрыто без подвтерждения */
  ON_CLOSED: Symbol('ON_CLOSED'),
};